import { HttpContextToken } from '@angular/common/http';

export const HTTP_SILENT_REQUEST = new HttpContextToken<boolean>(() => false);
